import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

import { Resume } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';
import { AuthService } from '../../../core/services/auth.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-add-certificates',
  templateUrl: './add-certificates.component.html',
  styleUrls: ['./add-certificates.component.css']
})
export class AddCertificatesComponent implements OnInit {
  public resume: Resume = {} as Resume;
  public valueStack: any;
  public descs = [
    '<p>Certified Yoga Teacher, Jivan Chakra Foundation, 2016<p>',
    '<p>Project Management Professional (PMP), XX Management Institute, 2013<p>',
    '<p>A+ Certification in HTML/CSS, NIIT, 2012<p>',
    '<p>OSHA Certification (Multi-industry / Health & Safety), AIIMS, 2011<p>',
    '<p>Hubspot Inbound Marketing Certification Course (Marketing), Coursera, 2014<p>',
    '<p>Language or ESL Certifications (General or Education), AILM, 2012<p>',
    '<p>Project Management Professional (PMP), IIFM, 2016<p>',
    '<p>Six Sigma Belts (Business), IIFM, 2016<p>',
    '<p>ISSA Personal Trainer Certification, GFFI Fitness Academy, 2014</div>'
  ];
  constructor(
    private router: Router,
    private authService: AuthService,
    private resumeService: ResumeService,
    private localStorageService: LocalStorageService,
    public utilService: UtilService
  ) {
    const resume_id = this.localStorageService.get('resume_id');
    if (resume_id) {
      this.resumeService.getResumeById(resume_id).subscribe(res => {
        this.valueStack = res;
        this.resume = res.Resume;
      });
    }
  }

  save() {
    this.resumeService.editResume(this.resume).subscribe(res => {
      this.resume = res.resume;
      this.router.navigate(['/resume/summary']);
    });
  }
  append(model, html) {
    model.certificates += html;
  }

  ngOnInit() {
  }
  goToTheme () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }
}
